import { SortType } from "./sortTypes";
import { FilterType } from "./filterTypes";

export const AuditSortTypes: SortType[] = [
    { field: "occurred_at_max", text: "Newest first", isReversed: false },
    { field: "occurred_at_max", text: "Oldest first", isReversed: true },
    { field: "total_events", text: "Most events", isReversed: true },
    { field: "total_events", text: "Fewest events", isReversed: false },
    { field: "actor_email", text: "Actor A–Z", isReversed: true },
    { field: "actor_email", text: "Actor Z–A", isReversed: false },
];

export const AuditFilterType: FilterType[] = [
    {
        field: "occurred_at",
        options: [],
        text: "From date - To date",
        title: "Occurred at",
        type: "date_range_utc",
    },
    {
        field: "action",
        options: [],
        text: "Action (comma-separated allowed)",
        title: "Action",
        type: "text",
    },
    {
        field: "actor_email",
        options: [],
        text: "Actor email",
        title: "Actor email",
        type: "text",
    },
    {
        field: "actor_id",
        options: [],
        text: "Actor id",
        title: "Actor id",
        type: "text",
    },
    {
        field: "code",
        options: [],
        text: "Code (root/entity)",
        title: "Code",
        type: "text",
    },
    {
        field: "request_ip",
        options: [],
        text: "Request IP",
        title: "Request IP",
        type: "text",
    },
    {
        field: "request_path",
        options: [],
        text: "Request path",
        title: "Request path",
        type: "text",
    },
    {
        field: "request_user_agent",
        options: [],
        text: "User agent",
        title: "User agent",
        type: "text",
    },
    {
        field: "is_root",
        options: [
            { text: "Root only", value: "true" },
            { text: "Non-root only", value: "false" },
        ],
        text: "All event kinds",
        title: "Root event",
    },
    {
        field: "entity_type",
        options: [],
        text: "Entity type (app.model)",
        title: "Entity type",
        type: "text",
    },
    {
        field: "entity_id",
        options: [],
        text: "Entity id",
        title: "Entity id",
        type: "text",
    },
    {
        field: "root_entity_type",
        options: [],
        text: "Root type (app.model)",
        title: "Root type",
        type: "text",
    },
    {
        field: "root_entity_id",
        options: [],
        text: "Root id",
        title: "Root id",
        type: "text",
    },
    {
        field: "request_id",
        options: [],
        text: "Request id",
        title: "Request id",
        type: "text",
    },
];


